import React, { useEffect } from "react";
import { projectsInfo } from "../../assets/data/projects";
import { ProjectCard } from "./projectCard/projectCard";
import projectImage from "../../assets/images/project.jpg";
import { Banner } from "../../components/banner/index.js";

export const Project = ({ match }) => {
  let result = projectsInfo.find(
    (item) => item.id.toString() === match.params.id
  );

  useEffect(() => {
    if (result !== undefined) {
      document.title = "Projects - " + result.title + " - Portfolio AV";
    } else {
      document.title = "Projects - Portfolio AV";
    }
  }, [result]);

  const showDetails = (result) => {
    return (
      <div>
        {result !== undefined ? (
          <ProjectCard key={result.id} project={result} />
        ) : (
          <h1>Er liep iets mis bij het ophalen van het project of het project bestaat niet.</h1>
        )}
      </div>
    );
  };

  return (
    <div>
      {result !== undefined && (
        <Banner image={projectImage} text={result.title} />
      )}

      <div className={[" Container"]}>
        {showDetails(result)}
      </div>
    </div>
  );
};
